
import TranResourcesApi from './src/Tranresources'
import RegionList from './src/RegionList'
import Records from './src/Records'


let apis = {
   TranResourcesApi,
   RegionList,
   Records
};

export default apis;
